import React, { PureComponent } from 'react';

type ECGClientProps = {
  children?: React.ReactNode;
};

class ECGClient extends PureComponent<ECGClientProps> {
  // eslint-disable-next-line react/static-property-placement -- TS class field typing makes the "outside class body" form awkward here
  static defaultProps = {
    children: {},
  };

  /**
   * Emits the ECG client container markup. Pulls children off props and wraps them in one div.
   *
   * @returns The rendered wrapper div containing the children.
   */
  render() {
    const { children } = this.props;
    return <div>{children}</div>;
  }
}

export default ECGClient;
